import React from 'react'
import { useRouter } from 'next/router'

import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { PENGELOLAAN_KINERJA_KS_PENILAI_PATH } from 'app/KinerjaShared/constants/path'
import BerandaKepalaSekolahPenilai from 'app/KinerjaPage/pages/BerandaKepalaSekolahPenilai'
import BerandaGuru from 'app/KinerjaPage/pages/BerandaGuru'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { PageGuardGuru } from 'app/KinerjaPage/components/PageGuardGuru'
import PageGuardKs from 'app/KinerjaKSPage/components/PageGuardKs'

import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-enabled'] || false

    if (!enabled) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }
  },
})

const KinerjaIndex = ({ toggle }: PageProps) => {
  const router = useRouter()
  if (router.asPath.includes(PENGELOLAAN_KINERJA_KS_PENILAI_PATH)) {
    return (
      <PageGuardKs>
        <BerandaKepalaSekolahPenilai
          isKinerjaPelaksanaanEnabled={toggle?.['kinerja-pelaksanaan-enabled']}
          isKinerjaPenilaianDemoEnabled={
            toggle?.['kinerja-penilaian-demo-mode-enabled']
          }
        />
      </PageGuardKs>
    )
  }
  return (
    <PageGuardGuru>
      <BerandaGuru
        isPengaliranKinerjaStatusEnabled={
          toggle?.['kinerja-konfirmasi-unor-enabled']
        }
      />
    </PageGuardGuru>
  )
}

KinerjaIndex.Layout = KinerjaLayout

KinerjaIndex.layoutOpts = {
  hasHeader: true,
}

export default KinerjaIndex
